import {
    DEAL_SUMMARY_REQUEST_QUOTE,
    DEAL_SUMMARY_QUOTE_REQUESTED,
    DEAL_SUMMARY_VIEW_QUOTE,
    DEAL_SUMMARY_ACCEPTED_DEAL,
    DEAL_SUMMARY_DEAL_PROPOSAL
} from '../constants';

export const getRoute = (route: string, baseRoute?: string): string => {
    baseRoute = baseRoute || '';
    return `${baseRoute}${route}`;
};

export const getAllRoutes = (baseRoute?: string): { [key: string]: string } => {
    return {
        requestQuote: getRoute(DEAL_SUMMARY_REQUEST_QUOTE, baseRoute),
        quoteRequested: getRoute(DEAL_SUMMARY_QUOTE_REQUESTED, baseRoute),
        viewQuote: getRoute(DEAL_SUMMARY_VIEW_QUOTE, baseRoute),
        acceptedDeal: getRoute(DEAL_SUMMARY_ACCEPTED_DEAL, baseRoute),
        dealProposal: getRoute(DEAL_SUMMARY_DEAL_PROPOSAL, baseRoute)
    };
};
